// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { PublicApi } from '@digitalasset/allocation-instruction-api-ts-client';
import React, { useContext } from 'react';

export const AllocationInstructionApiContext = React.createContext<PublicApi | undefined>(
  undefined,
);

export const useAllocationInstructionApiClient: () => PublicApi = () => {
  const client = useContext<PublicApi | undefined>(AllocationInstructionApiContext);
  if (!client) {
    throw new Error('AllocationInstruction client not initialized');
  }
  return client;
};
